module.exports = __webpack_public_path__ + "static/media/willmoore.bc06d6b8.jpg";